import { IStepTool } from "../FlowEditor/Toolbox/IStepTool";
import { domainStore } from "../../store/domainStore";
import _ from "lodash";
import toolIcons from "./toolIcons";

import ingestedEventIcon from "../../assets/img/ingested-event.svg";
import siteTrackingEventIcon from "../../assets/img/site-tracking-event.svg";
import zapierIcon from "../../assets/img/zapier.svg";
import { enchargeSiteTrackingSlug } from "encharge-domain/helpers/constants";
import {
  TOOLBOX_STEPS,
  ToolboxStep,
} from "encharge-domain/lib/helpers/toolbox_steps";

// The list itself is shared with the AI tools, which build flows from the same steps: see
// encharge-domain helpers/toolbox_steps. To add a step to the toolbox, add it there.
// There an icon is a name; here it becomes the image the editor draws.
const iconOf = (name: string): string =>
  name.startsWith("/") ? `${process.env.PUBLIC_URL}${name}` : toolIcons[name];

const ICON_FIELDS = [
  "operationIcon",
  "operationIconToolbox",
  "operationIconApps",
];

// What the AI tools do with a step (`ai`) is not part of what the editor shows or drags.
const toTool = (
  step: ToolboxStep
): Overwrite<IStepTool, { service?: IService }> =>
  ({
    ..._.omit(step, "ai"),
    display: _.mapValues(step.display, (value, field) =>
      ICON_FIELDS.includes(field) ? iconOf(value as string) : value
    ),
  } as Overwrite<IStepTool, { service?: IService }>);

const currentTools: Overwrite<
  IStepTool,
  { service?: IService }
>[] = TOOLBOX_STEPS.map(toTool);

export const getAllTools = () => {
  const services = domainStore.servicesStore.services.current();
  if (!services) return undefined;
  return currentTools.map((tool) => {
    // find this tool's service
    tool.service = _.find(services, (service) => service.id === tool.serviceId);
    return tool as IStepTool;
  });
};

export const getTool = (
  serviceId: IService["id"],
  operationKey: IIntegrationStep["data"]["operationKey"]
) => {
  for (const tool of currentTools) {
    if (tool.serviceId === serviceId && tool.operationKey === operationKey) {
      return tool;
    }
  }
  return undefined;
};

export const getServiceIcon = (serviceId: IService["id"]) => {
  if (serviceId === "segment") {
    return toolIcons["./segment-logo.png"];
  }
  if (serviceId === "zapier") {
    return zapierIcon;
  }
  if (serviceId === enchargeSiteTrackingSlug) {
    return siteTrackingEventIcon;
  }
  if (serviceId === "ingested-event") {
    return ingestedEventIcon;
  }
  if (serviceId === "woocommerce") {
    return toolIcons["./woocommerce.svg"];
  }
  if (serviceId === "shopify") {
    return toolIcons["./shopify.svg"];
  }
  if (serviceId === "thrivecart") {
    return toolIcons["./thrivecart.svg"];
  }

  for (const tool of currentTools) {
    if (tool.serviceId === serviceId) {
      return tool.display.operationIconApps || tool.display.operationIcon;
    }
  }
  return undefined;
};
